import React, { PropsWithChildren } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import {
  StyledModalBody,
  StyledModalCloseButton,
  StyledModalHeader,
  StyledSpinner,
  StyledModal,
} from "../styles";

interface ModalWrapperProps {
  children: any;
  isOpen: boolean;
  isProcessing: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  labelOk: string;
  labelCancel: string;
  maxWidth?: string;
  overflowVisible?: boolean;
}

export const ConfirmModal = ({
  children,
  isOpen,
  onClose,
  title,
  isProcessing,
  onConfirm,
  labelOk,
  labelCancel,
}: PropsWithChildren<ModalWrapperProps>) => {
  return (
    <StyledModal centered show={isOpen} onHide={onClose} backdrop="static">
      <StyledModalHeader closeButton>
        <h3 className="text-center">{title}</h3>
      </StyledModalHeader>
      <StyledModalBody>
        {children}
        <Container className="pt-3 text-center">
          {isProcessing ? (
            <StyledSpinner className="fa fa-spinner fa-spin ml-3" />
          ) : (
            <Row>
              <Col className="text-right">
                <Button onClick={onConfirm}>
                  <div className="font-weight-bold">{labelOk}</div>
                </Button>
              </Col>
              <Col className="text-left">
                <StyledModalCloseButton className="ml-0" onClick={onClose}>
                  <div className="font-weight-bold">{labelCancel}</div>
                </StyledModalCloseButton>
              </Col>
            </Row>
          )}
        </Container>
      </StyledModalBody>
    </StyledModal>
  );
};
